import { render } from "./ProjectModal.vue?vue&type=template&id=05f839a4&scoped=true&ts=true"
import script from "./ProjectModal.ts?vue&type=script&lang=ts"
export * from "./ProjectModal.ts?vue&type=script&lang=ts"

import "./ProjectModal.scss?vue&type=style&index=0&id=05f839a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f839a4"]])

export default __exports__